module.exports = __webpack_public_path__ + "nodejs-icon.svg?06c091612c178230b65169e6a08e869c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/nodejs-icon.svg
// module id = 47
// module chunks = 0